<template>
<div v-if="searchNewsList">
    <ul class="search">
        <li
          class="search__item"
          v-for="(item, index) in searchNewsList"
          :key="index"
        >
          <router-link
          :to="`/searchDetail/${item.id}/${item.accessName}`"
          >
          <div class="search__item__div" v-html="item.title"></div>
          </router-link>
        </li>
    </ul>
    <div class="iconfont__wrapper" @click="routeBack">
      <span class="iconfont">&#xe6a0;</span>
    </div>
</div>
<div
  v-else
  class="spin"
  :style="{height: '30px', marginTop: searchSpin}"
>
    <a-spin size="large" :style="{marginTop: searchSpin/3}" tip="加载中..."/>
</div>
</template>

<script>
import { computed, ref } from 'vue'
import { get } from '../../utils/request'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
export default {
  name: 'SearchList',
  setup () {
    const searchSpin = ref()
    const store = useStore()
    const router = useRouter()
    // const searchNewsList = computed(() => store.state.searchNewsList)
    const newspaper = computed(() => store.state.newspaper)
    const inputValue = computed(() => store.state.inputValue)
    searchSpin.value = window.innerHeight / 2 - 20 + 'px'
    const searchNewsList = ref()
    const getNewspaperPage = async () => {
      const url = `/tableNewsController/searchTableNews?accessName=${newspaper.value}&fullSearchText=${inputValue.value}`
      const result = await get(url)
      document.title = '搜索列表'
      searchNewsList.value = result.list
      // store.dispatch('searchNewsList', searchNewsList)
      // router.push('/search')
    }
    getNewspaperPage()
    const routeBack = () => {
      router.back()
    }
    return {
      searchNewsList,
      searchSpin,
      routeBack
    }
  }
}
</script>
<style lang="scss" scoped>
.search{
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 0 0.5rem;
  box-sizing: border-box;
  &__item{
    font-size: 0.5rem;
    border-bottom: 0.001rem solid #ddd;
    line-height: 1rem;
    &__div{
       color: #666666;
    }
  }
}
.spin{
  text-align: center;
}
.iconfont__wrapper{
  position: fixed;
  bottom: 5rem;
  left: 1rem;
  width: 45px;
  height: 45px;
  line-height: 43px;
  border-radius: 50%;
  background-color: #DE1B23;
  text-align: center;
  opacity: 0.5;
  vertical-align: middle;
  .iconfont{
    color: #ffffff;
    font-size: 0.6rem;
  }
}
</style>
